module.exports = __webpack_public_path__ + "static/media/Janet Chu.7f9cd7ed.png";